/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IdentitySourceName = {
    AwsOrganization: 'aws_organization',
    AwsAccount: 'aws_account',
    Auth0Domain: 'auth0_domain',
    Slashid: 'slashid',
    AzureTenant: 'azure_tenant',
    EntraTenant: 'entra_tenant',
    GcpProject: 'gcp_project',
    GcpOrganization: 'gcp_organization',
    GateInstance: 'gate_instance',
    SnowflakeAccount: 'snowflake_account',
    OktaOrg: 'okta_org',
    GoogleWorkspaceInstance: 'google_workspace_instance',
    ActiveDirectory: 'active_directory',
    PostgresInstance: 'postgres_instance',
    KeeperAccount: 'keeper_account'
} as const;
export type IdentitySourceName = typeof IdentitySourceName[keyof typeof IdentitySourceName];


export function IdentitySourceNameFromJSON(json: any): IdentitySourceName {
    return IdentitySourceNameFromJSONTyped(json, false);
}

export function IdentitySourceNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentitySourceName {
    return json as IdentitySourceName;
}

export function IdentitySourceNameToJSON(value?: IdentitySourceName | null): any {
    return value as any;
}

